const OfferSchema = ({
  name,
  description,
  price,
  priceCurrency = "INR",
  url,
  availability = "https://schema.org/InStock"
}) => ({
  "@context": "https://schema.org",
  "@type": "Offer",
  "name": name,
  "description": description,
  "availability": availability,
  "url": url,
  "itemOffered": {
    "@id": "https://onbbits.io/#software"
  },

  ...(price !== undefined && {
    "price": price,
    "priceCurrency": priceCurrency
  })
});

export default OfferSchema;